import type { IntlShape } from 'react-intl';

import { User } from '../types/User';

interface Options {
  isCurrentUser?: boolean;
  isDeleted?: boolean;
  placeholderName?: string;
  shouldAbbreviateLastName?: boolean;
}

export const getUserName = ({
  user,
  options = {},
  intl,
}: {
  user: User;
  options?: Partial<Options>;
  intl: IntlShape;
}) => {
  const { firstName, lastName } = user;
  const {
    placeholderName,
    shouldAbbreviateLastName = false,
    isDeleted = false,
    isCurrentUser = false,
  } = options;

  const defaultPlaceholder = placeholderName
    ? placeholderName
    : intl.formatMessage({
        id: 'GetUserName.unknown',
        defaultMessage: 'Unknown',
        description: 'Placeholder text for unknown user name',
      });

  // TODO remove isDeleted from options
  const isUserDeleted = user.isDeleted ?? isDeleted;

  const nameList = [];
  if (firstName) {
    nameList.push(firstName);
  }
  if (lastName) {
    nameList.push(shouldAbbreviateLastName ? `${lastName[0]}.` : lastName);
  }
  if (isUserDeleted) {
    nameList.push(
      intl.formatMessage({
        id: 'GetUserName.deactivated',
        defaultMessage: '(Deactivated)',
        description: 'Label indicating a user account has been deactivated',
      }),
    );
  }
  if (isCurrentUser) {
    nameList.push(
      intl.formatMessage({
        id: 'GetUserName.you',
        defaultMessage: '(You)',
        description: 'Label indicating the current user',
      }),
    );
  }

  return nameList.join(' ') || defaultPlaceholder;
};
